__turbopack_context__.v({
  "headerContainer": "headerLayoutDesktop-module-scss-module__lMuIyW__headerContainer",
  "headerHolder": "headerLayoutDesktop-module-scss-module__lMuIyW__headerHolder",
  "links": "headerLayoutDesktop-module-scss-module__lMuIyW__links",
  "logoWrapper": "headerLayoutDesktop-module-scss-module__lMuIyW__logoWrapper",
  "panelButtons": "headerLayoutDesktop-module-scss-module__lMuIyW__panelButtons",
  "searchContainer": "headerLayoutDesktop-module-scss-module__lMuIyW__searchContainer",
});
